// extracted by mini-css-extract-plugin
export default {"inputBox":"numberInput_inputBox__sbcgy","reqText":"numberInput_reqText__u3MGk","errorMsg":"numberInput_errorMsg__gml7L"};